module.exports = __webpack_public_path__ + "img/AGD_ack_logo-white@2x.69871e50.png";